import { useMutation } from 'react-query';

import { AddOnCellData, MutationFunction, useRequest } from '@frontend/api';

export const useUpdateAddOnCell: MutationFunction<
  AddOnCellData,
  {
    addOnCellId: number;
    data: {
      manualPrice: string;
      manualUnitPrice?: string;
    };
  }
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ addOnCellId, data }) =>
      request(`/quotes/components/add_on_cells/${addOnCellId}`, {
        init: { method: 'PATCH', body: data },
        query,
      }),
    ...queryOptions,
  });
};
